//rem计算
export default {
	init: function(e) {
		if(!-[1, ]) {
			return false;
		} //判断是否IE浏览器
		function t() {
			var width = html.getBoundingClientRect().width;
			width / o > 750 && (width = 750 * o), window.rem = width / 15, html.style.fontSize = window.rem + "px"
		}
		var o, i, timer, document = window.document,
			html = document.documentElement,
			meta = document.querySelector('meta[name="viewport"]');
		if(meta) {
			var d = meta.getAttribute("content").match(/initial\-scale=(["']?)([\d\.]+)\1?/);
			d && (i = parseFloat(d[2]), o = parseInt(1 / i))
		} else meta = document.createElement("meta"), meta.setAttribute("name", "viewport"), meta.setAttribute("content", "width=device-width, initial-scale=1, user-scalable=no, minimal-ui"), html.firstElementChild.appendChild(meta);
		window.addEventListener("resize", function() {
			clearTimeout(timer), timer = setTimeout(t, 300)
		}, !1), window.addEventListener("pageshow", function(window) {
			window.persisted && (clearTimeout(timer), timer = setTimeout(t, 300))
		}, !1), "complete" === document.readyState ? document.body.style.fontSize = 12 * o + "px" : document.addEventListener("DOMContentLoaded", function() {
			document.body.style.fontSize = 12 * o + "px"
		}, !1), t();
	}
}


// WEBPACK FOOTER //
// ./src/rem/index.js